export default from './BidFormValueField';



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/AutoCalculation/components/BidFormValueField/index.js